var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGmx = function SvgGmx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19 12.015 4.5 2 19h13.954l-3.939-5.534-1.953 2.876H7.985l4.032-5.781L17.844 19 22 19Z",
    fill: "#000"
  })));
};
export { SvgGmx as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMiAxOUwxMi4wMTUzIDQuNTAwNjdMMiAxOUgxNS45NTM2TDEyLjAxNTMgMTMuNDY2M0wxMC4wNjE3IDE2LjM0MTZINy45ODU0M0wxMi4wMTY2IDEwLjU2MDZMMTcuODQ0MiAxOS4wMDA3TDIyIDE5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";